module.exports = __webpack_public_path__ + "img/nl_Ecran 6.e53787de.jpg";